import React, { useEffect, useRef, useState } from "react";
import Editor from "@monaco-editor/react";
import { ReactComponent as LeftIcon } from "../../../../../assets/svg/left-arrow.svg";
import _ from "lodash";
import SplitPane, { Pane } from "../../../../../plugin/react-split-pane";
import TarsChatBot from "../../../Assisted/forms/create/properties/TarsChatBot";
import TarsIcon from '../../../../../assets/images/tarsIcon.png'
interface IProps {
    close: () => void;
    onChange: (value: any) => void;
    editorContext: {
        visibility: boolean
        type: string
        source: string
        where: string
    }
    isCheckedIn: boolean;
    customdef?: any;
}

export const HtmlandCssEditor: React.FC<IProps> = ({ isCheckedIn, close, editorContext, customdef, onChange }) => {
    const { source, where, type } = editorContext
    const [htmlCode, setHtmlCode] = useState("")
    const [cssElement, setCssElement] = useState("")

    useEffect(() => {
        if (editorContext.type === "html") {
            setHtmlCode(editorContext.source)
        } else if (editorContext.type === "css") {
            setCssElement(editorContext.source)
        }
    }, [editorContext])
    const [isVisibleTars, setIsVisibleTars] = useState<boolean>(true)
    return (
        <div
            title="html_css_editor"
            key="click-code-editor"
            style={{ position: "fixed", zIndex: 999, top: '0px', width: "100%", height: "100vh", right: "0px", padding: "0px", margin: "0px", maxWidth: "100%" }}
        >
            <div style={{ height: "100%", width: "100%", display: "flex", background: "white" }}>
                <SplitPane className={""} paneStyle={{ width: window.innerWidth + "px" }} >
                    <Pane className={' override-component-pane'} minSize={!isVisibleTars ? "100%" : "40%"} initialSize={!isVisibleTars ? "100%" : "60%"} maxSize={!isVisibleTars ? "100%" : "80%"}>
                        <div
                            style={{
                                backgroundColor: "#FCFCFC",
                                height: "100%",
                                width: "100%",
                                boxShadow: "-3px 4px 14px rgba(0, 0, 0, 0.13)",
                            }}
                        >
                            <Header setIsVisibleTars={setIsVisibleTars} isVisibleTars={isVisibleTars} isCheckedIn={isCheckedIn} close={close} editorContext={editorContext} onChange={onChange} htmlCode={htmlCode} cssElement={cssElement} type={type} />
                            <EditorPanel customdef={customdef} isCheckedIn={isCheckedIn} source={source} type={type} where={where} close={close} setHtmlCode={setHtmlCode} setCssElement={setCssElement} />
                        </div>
                    </Pane>
                    {isVisibleTars &&
                        <Pane className={' override-component-pane'} minSize="30%" initialSize="40%" maxSize="60%">
                            <TarsChatBot editorRef={"editorRef"} type={"inline"} setIsVisibleTars={setIsVisibleTars} ></TarsChatBot>
                        </Pane>}
                </SplitPane>
            </div>
        </div>
    );
};

interface IHeader {
    close: () => void;
    isCheckedIn: boolean;
    onChange: (value: any) => void;
    htmlCode: any;
    cssElement: any;
    type: string;
    isVisibleTars: boolean;
    setIsVisibleTars: (value: boolean) => void;
    editorContext: {
        visibility: boolean
        type: string
        source: string
        where: string
    }
}
const Header: React.FC<IHeader> = ({ isCheckedIn, close, onChange, htmlCode, cssElement, type, editorContext, isVisibleTars, setIsVisibleTars }) => {
    return (
        <div
            className="flex items-center justify-between"
            style={{ backgroundColor: "#2239790F", padding: "12px" }}
        >
            <div className="flex items-center space-x-3">
                <LeftIcon
                    className="cursor-pointer"
                    width={16}
                    height={15}
                    onClick={close}
                />
                <h3 style={{ color: "#0466C8" }}>{type === "html" ? "HTML editor" : "CSS editor"}</h3>
            </div>

            {isCheckedIn && <div className="space-x-8 flex items-center">
                <button style={{ color: "#505F7B" }} onClick={() => close()}>Cancel</button>
                <button
                    style={{
                        height: "26px",
                        width: "50px",
                        color: "#FFF",
                        backgroundColor: "#052f35 ",
                        borderRadius: 3,
                    }}
                    onClick={() => {
                        let event = new KeyboardEvent("keydown", {
                            key: "s",
                            code: "KeyS",
                            ctrlKey: true,
                        });
                        document.dispatchEvent(event);
                        if (type === "html") {
                            onChange(htmlCode)
                        } else {
                            onChange(cssElement)
                        }
                        close()
                    }}
                >
                    Save
                </button>
                {!isVisibleTars ? <img onClick={(() => { setIsVisibleTars(true) })} style={{ cursor: "pointer", height: "38px", width: "38px" }} src={TarsIcon} alt=""></img> : null}
            </div>}
        </div>
    );
};

interface IEditor {
    source: string
    where: string,
    type: any,
    isCheckedIn?: boolean
    customdef?: string
    close: () => void;
    setHtmlCode: (value: any) => void;
    setCssElement: (value: any) => void;
}

// TODO: fetch function typedefs
const EditorPanel: React.FC<IEditor> = ({ isCheckedIn, source, type, setHtmlCode, setCssElement }) => {
    const additionalOptions = {
        overviewRulerLanes: 0,
        overviewRulerBorder: false

    }
    const instanceRef: any = useRef(null);
    const editorRef: any = instanceRef;

    function handleEditorDidMount(editor: any) {
        editorRef.current = editor;
        const editorModel = editor.getModel();
        const editableArea = editor.getModel().getLineCount()
        if (editableArea >= 100) {
            /*
             * This Promise.resolve() sends the code to the micro task queue
             * And it gets called before the event queue ( micro task queue has more priority than event queue)
             * Thus, Promise.resolve() will be better than a setTimeout(fn,0) here
             * If we do it synchronously, it affects some of monaco editor's functions
             */
            Promise.resolve().then(() => editor.trigger("someIdString", "undo"));
        }
    }

    const beforeMount = (editor: any) => {
        console.log({ editor })
    }
    return (
        <Editor
            defaultValue={source}
            language={type}
            path={type}
            line={100}
            onMount={handleEditorDidMount}
            beforeMount={beforeMount}
            options={{
                fontSize: 14,
                trimAutoWhitespace: true,
                renameOnType: true,
                autoIndent: "full",
                autoClosingBrackets: 'languageDefined',
                lineNumbers: "on",
                scrollBeyondLastLine: false,
                readOnly: !isCheckedIn,
                quickSuggestions: {
                    "other": true,
                    "comments": true,
                    "strings": true
                },
                parameterHints: {
                    enabled: true
                },
                suggestOnTriggerCharacters: true,
                acceptSuggestionOnEnter: "on",
                tabCompletion: "on",
                wordBasedSuggestions: true,
                selectOnLineNumbers: true,
                roundedSelection: true,
                cursorStyle: 'line',
                minimap: {
                    enabled: false
                },
                ...additionalOptions
            }}
            keepCurrentModel={false}
            onChange={(e: any) => { type === "html" ? setHtmlCode(e) : setCssElement(e) }}
        />
    );
};
